import React from "react";

import moment from "moment";
import { Row, Col } from "react-bootstrap";

import { translate, getLanguage } from "../Translation/Translation";

class OSShipCardTable extends React.Component {
  render() {
    let RESULT = [];

    const ROUTE = (
      <Row
        key={1}
        style={{
          margin: "0px",
          background: "rgb(140,216,248)",
          padding: "10px 0px",
          color: "rgb(40,76,100)",
          fontWeight: "bold",
        }}
      >
        <Col lg={5} md={5} sm={12} xs={12} className="tableHeader">
          <div className="headerLabel">
            {" "}
            {translate(getLanguage(), "Route")}{" "}
          </div>
        </Col>
        <Col
          lg={2}
          md={2}
          sm={4}
          xs={4}
          className="tableHeader noPaddingOnMediumAndHigher"
          style={{ padding: "0" }}
        >
          <div className="headerLabel">
            {" "}
            {translate(getLanguage(), "Departure")}{" "}
          </div>
        </Col>
        <Col
          lg={2}
          md={2}
          sm={4}
          xs={4}
          className="tableHeader"
          style={{ paddingLeft: "15px", paddingRight: "0px" }}
        >
          <div className="headerLabel">
            {" "}
            {translate(getLanguage(), "Arrival")}{" "}
          </div>
        </Col>
        <Col lg={3} md={3} sm={4} xs={4} className="tableHeader">
          <div className="headerLabel">
            {" "}
            {translate(getLanguage(), "Trip Duration")}{" "}
          </div>
        </Col>
      </Row>
    );
    RESULT.push(ROUTE);

    let AFTER_FINAL_STOP = false;

    for (let i = 0; i < this.props.stops.length - 1; i++) {
      let hours = Math.floor(this.props.stops[i].duration / 60);
      let minutes = Math.floor(this.props.stops[i].duration) % 60;

      if (hours < 10) {
        hours = `0${hours}`;
      }
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }

      const duration = `${hours}:${minutes}`;

      const ROUTE = (
        <Row
          className="OpacityRow TableRow"
          style={AFTER_FINAL_STOP ? { opacity: "0.3" } : { opacity: "1" }}
          key={this.props.stops[i].departureDateTime}
        >
          <Col lg={5} md={5} sm={12} xs={12}>
            <div className="portName">{this.props.stops[i].stop.name}</div>
            <div className="portArrow">
              <svg
                viewBox="0 0 1000 1000"
                className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1"
              >
                <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z"></path>
              </svg>
            </div>
            <div className="portName">{this.props.stops[i + 1].stop.name}</div>
          </Col>
          <Col
            lg={2}
            md={2}
            sm={4}
            xs={4}
            className="noPaddingOnMediumAndHigher"
          >
            <div className="portName">
              {moment(
                this.props.stops[i].departureDateTime,
                "YYYY-MM-DD HH:mm:SS"
              ).format("HH:mm")}{" "}
            </div>
          </Col>
          <Col lg={2} md={2} sm={4} xs={4}>
            <div className="portName">
              {moment(
                this.props.stops[i + 1].arrivalDateTime,
                "YYYY-MM-DD HH:mm:SS"
              ).format("HH:mm")}{" "}
            </div>
          </Col>
          <Col lg={3} md={3} sm={4} xs={4}>
            <div className="portName">{duration} </div>
          </Col>
        </Row>
      );
      if (this.props.stops[i + 1].stop.name === this.props.finalStop) {
        AFTER_FINAL_STOP = true;
      }

      RESULT.push(ROUTE);
    }

    return (
      <Row
        style={{
          margin: "0px",
          marginTop: "10px",
          boxShadow: "0px 0px 7px #888888",
        }}
      >
        {RESULT}
      </Row>
    );
  }
}

export default OSShipCardTable;



// WEBPACK FOOTER //
// ./src/components/OSShipCard/OSShipCardTable.js